import { Link } from 'react-router-dom';

interface ArticleCardProps {
  id: number;
  title: string;
  excerpt: string;
  category: string;
  categorySlug: string;
  image: string;
  publishDate: string;
  views: number;
  hot?: boolean;
  featured?: boolean;
}

export default function ArticleCard({
  id,
  title,
  excerpt,
  category,
  categorySlug,
  image,
  publishDate,
  views,
  hot,
  featured,
}: ArticleCardProps) {
  return (
    <article className="bg-background-50 border border-background-200/70 rounded-xl overflow-hidden group hover:border-primary-200 transition-colors duration-300">
      <Link to={`/article/${id}`} className="block cursor-pointer" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
        <div className="relative overflow-hidden">
          <div className="w-full aspect-[16/9] overflow-hidden">
            <img
              src={image}
              alt={title}
              title={`${title} - 黑料导航`}
              className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
            />
          </div>
          <div className="absolute top-3 left-3 flex gap-2 flex-wrap">
            <Link
              to={`/category/${categorySlug}`}
              className="px-2.5 py-1 bg-primary-500 text-white text-xs font-medium rounded-full whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-colors"
              onClick={(e) => { e.stopPropagation(); window.scrollTo({ top: 0, behavior: 'smooth' }); }}
            >
              {category}
            </Link>
            {hot && (
              <span className="px-2.5 py-1 bg-accent-500 text-white text-xs font-medium rounded-full whitespace-nowrap flex items-center gap-1">
                <i className="ri-fire-line"></i> 热榜
              </span>
            )}
            {featured && !hot && (
              <span className="px-2.5 py-1 bg-secondary-500 text-white text-xs font-medium rounded-full whitespace-nowrap">
                精选
              </span>
            )}
          </div>
        </div>
        <div className="p-4 md:p-5">
          <h3 className="text-base md:text-lg font-semibold text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
            {title}
          </h3>
          <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2 mb-4">
            {excerpt}
          </p>
          <div className="flex items-center justify-between text-xs text-foreground-400">
            <span className="flex items-center gap-1">
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-time-line"></i>
              </div>
              {publishDate}
            </span>
            <span className="flex items-center gap-1">
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-eye-line"></i>
              </div>
              {views >= 10000 ? `${(views / 10000).toFixed(1)}万` : views}
            </span>
          </div>
        </div>
      </Link>
    </article>
  );
}